module.exports = __webpack_public_path__ + "static/img/herdegen-zac.05e7dab.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/herdegen-zac.jpg
// module id = wTyV
// module chunks = 0